// Tells the other tabs of this browser that the user logged out (FR-024; research R5). Only the
// message type is sent: no token, name or email.
const CHANNEL = "akaiva.session";
type Message = { type: "signedOut" };

function open(): BroadcastChannel | null {
  return typeof BroadcastChannel === "undefined"
    ? null
    : new BroadcastChannel(CHANNEL);
}

export const crossTab = {
  broadcastSignedOut(): void {
    const channel = open();
    if (!channel) return;
    channel.postMessage({ type: "signedOut" } satisfies Message);
    channel.close();
  },
  onSignedOut(listener: () => void): () => void {
    const channel = open();
    if (!channel) return () => {};
    channel.onmessage = (event: MessageEvent<unknown>) => {
      const data = event.data as Partial<Message> | null;
      if (data?.type === "signedOut") listener();
    };
    return () => channel.close();
  },
};

export type CrossTab = typeof crossTab;
